import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { PortfolioCorrectionForm } from './PortfolioCorrectionForm'

export function PortfolioCorrectionCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.unitlink.usePortfolioCorrectionActions')({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="unitLink.PortfolioCorrectionCommandData"
      title={translate('portfolioCorrectionModalButton.title')}
      commandDataForm={PortfolioCorrectionForm}
      {...props}
      submit={submit}
    />
  )
}
